function borders() {
  let styles = `
    .border { border: 1px solid #dedede; }
    .border--none { border: none !important; }

    .border---top, .border--bottom, .border--right, .border--left { border: none; }
    .border--top { border-top: 1px solid #dedede; }
    .border--bottom { border-bottom: 1px solid #dedede; }
    .border--right { border-right: 1px solid #dedede; }
    .border--left { border-left: 1px solid #dedede; }

    .border--xs { border-width: 2px; }
    .border--sm { border-width: 5px; }
    .border--md { border-width: 10px; }
    .border--lg { border-width: 25px; }

    .radius--xs { border-radius: 3px; }
    .radius--sm { border-radius: 5px; }
    .radius--md { border-radius: 10px; }
    .radius--lg { border-radius: 300px; }

    hr  {
      border: none;
      height: 0;
      border-bottom: 1px solid #dedede;

      &.shorty {
        width: 60px;
      }
    }
     `;

  return styles;
}

export default borders;
